export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-male-1e24d7b5bff7362ecf5da1d5080ffe6a.svg";